import { Component, Injector, ViewChild } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'error-submitting-app',
  template: require('./error-submitting-app.component.html'),
  styles: [require('./error-submitting-app.component.scss')]
})
export class ErrorSubmittingAppComponent extends BaseRoute {
  @ViewChild('focusItem') focusItem;
  constructor(injector: Injector) {
    super(injector);
    this.loadingNext = false;
  }

  ngOnInit() {
    this.appActions.setData('stepUserIsOn', 0);
    this.errorCode = this.flowManager.requestId ? this.flowManager.requestId : '001';
    if (this.focusItem) {
      this.focusItem.nativeElement.focus();
    }
  }
}
